<template>
  <div class="app_form">
    <template>
      <el-backtop></el-backtop>
    </template>
    <van-nav-bar
      class="topBar"
      v-if="!isMobile"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <van-dropdown-menu
      :class="isMobile ? 'topBar isMobile' : 'topBar notMobile'"
      get-container="body"
      :close-on-click-outside="false"
      active-color="#1989fa"
    >
      <van-dropdown-item :title="isFilter() ? '已选择筛选条件' : '筛选'" ref="item">
        <van-form>
          <van-field
            v-model="queryParams.params.keyword"
            name="关键词"
            label="全局搜索"
            placeholder="请输入搜索关键词"
          />
          <van-field
            readonly
            clickable
            clearable
            name="picker"
            :value="queryParams.params.procDefKey"
            label="类型"
            placeholder="点击选择类型"
            @click="getServiceProcess"
          />
          <van-field
            readonly
            clickable
            clearable
            name="datetimePicker"
            :value="queryParams.params.startTime1"
            label="发起时间从"
            placeholder="点击选择时间"
            @click="timeOnClick('startTime1')"
          />
          <van-field
            readonly
            clickable
            clearable
            name="datetimePicker"
            :value="queryParams.params.startTime2"
            label="至"
            placeholder="点击选择时间"
            @click="timeOnClick('startTime2')"
          />
          <van-field
            readonly
            clickable
            clearable
            name="datetimePicker"
            :value="queryParams.params.endTime1"
            label="完成时间从"
            placeholder="点击选择时间"
            @click="timeOnClick('endTime1')"
          />
          <van-field
            readonly
            clickable
            clearable
            name="datetimePicker"
            :value="queryParams.params.endTime2"
            label="至"
            placeholder="点击选择时间"
            @click="timeOnClick('endTime2')"
          />
          <van-field
          v-if="type == '3'"
            readonly
            clickable
            clearable
            name="datetimePicker"
            :value="queryParams.params.dealTime1"
            label="处理时间从"
            placeholder="点击选择时间"
            @click="timeOnClick('dealTime1')"
          />
          <van-field
            v-if="type == '3'"
            readonly
            clickable
            clearable
            name="datetimePicker"
            :value="queryParams.params.dealTime2"
            label="至"
            placeholder="点击选择时间"
            @click="timeOnClick('dealTime2')"
          />
          <div style="margin: 10px; display: flex; justify-content: center">
            <van-button
              size="small"
              round
              native-type="submit"
              style="padding: 0 20px; margin-right: 20px"
              @click="clearData"
            >
              清空
            </van-button>
            <van-button
              size="small"
              round
              type="info"
              native-type="submit"
              style="padding: 0 20px"
              @click="onSubmit"
            >
              筛选
            </van-button>
          </div>
        </van-form>
      </van-dropdown-item>
      <van-dropdown-item v-model="value" :options="option" />
    </van-dropdown-menu>
    <!-- 日期选择框 -->
    <van-popup v-model="showPicker" position="bottom" get-container="#app">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        title="选择完整时间"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
    <!-- 流程弹出框 -->
    <van-popup v-model="showProcPicker" position="bottom" :style="{ height: '60%' }">
      <van-search
        v-model="queryParams.params.procDefKey"
        placeholder="请搜索类型选中点击确认"
        @input="getProcName"
      />
      <van-picker
        title="选择流程类型"
        show-toolbar
        visible-item-count="5"
        :columns="procList"
        @confirm="onConfirmProc"
        @cancel="showProcPicker = false"
      />
    </van-popup>
    <van-list
      :style="isMobile ? 'padding-top: 45px;' : 'padding-top: 90px;'"
      v-model="loadData"
      :finished="finished"
      finished-text="没有更多了"
      :immediate-check="false"
      @load="onLoad"
    >
      <el-card
        class="card_form"
        style="margin: 10px"
        v-for="(item, index) in data.length ? data : globalData"
        :key="index"
      >
        <div class="app_form_title" @click="onClickFlow(item)">
          <div style="display: flex; justify-content: space-between;">
            <span class="formName" v-if="data.length">{{ item.name | ellipsis }}</span>
            <span class="formName" v-else>{{ item.taskTitle }}</span>
            <div :class="'flow-commit complete ' + getApprovalColor(item)">
              {{ getApprovalStatusStr(item) }}
            </div>
          </div>
          <template class="step">
            <van-steps :active="active" direction="vertical">
              <van-step class="step-title">
                当前审批人:
                <template v-if="item.activeTaskList">
                  <span class="span" v-if="item.activeTaskList[0].assignee">
                    {{ item.activeTaskList[0].assigneeName }}
                  </span>
                  <!--或签的可选人-->
                  <template
                    v-else-if="
                      item.activeTaskList[0].candidateUsers &&
                      item.activeTaskList[0].candidateUsers.length > 0
                    "
                  >
                    <span
                      v-for="(cu, index) in item.activeTaskList[0].candidateUsers"
                      :key="index"
                    >
                      {{ cu.psnName }}
                    </span>
                  </template>
                </template>
                <span class="span" v-if="globalData.length">
                  {{
                    item.assigneeName && item.assigneeName != 'null'
                      ? item.assigneeName.split(' ').join(',') + ''
                      : ''
                  }}
                </span>
              </van-step>
              <template v-if="item.formInfo">
                <van-step v-for="(value, key) in item.formInfo" :key="key">
                  {{ key }}:
                  <span class="span">{{ value !== 'null' ? value : '' }}</span>
                </van-step>
              </template>
              <van-step>
                当前节点:
                <span class="span" v-if="item.activeTaskList">
                  {{ item.activeTaskList[0].name }}
                </span>
                <span class="span" v-if="globalData.length">
                  {{ item.nowTaskName }}
                </span>
              </van-step>

              <van-step>
                时效:
                <span class="span" v-if="item.activeTaskList">
                  {{ item.activeTaskList[0].dueDate }}
                </span>
              </van-step>
            </van-steps>
          </template>
        </div>
      </el-card>
    </van-list>
    <template
      v-if="
        (data == undefined || data.length <= 0) &&
        (globalData == undefined || globalData.length <= 0) &&
        !loadData
      "
    >
      <van-empty description="暂无数据" />
    </template>
    <van-dialog v-model="briefDialog" title="简报" show-cancel-button>
      <van-cell-group v-for="(item, index) in briefData" :key="index">
        <van-cell :value="item" :title="index" />
      </van-cell-group>
    </van-dialog>
  </div>
</template>
<script>
import {
  Step,
  Steps,
  Empty,
  List,
  Icon,
  Dialog,
  Cell,
  CellGroup,
  DropdownMenu,
  DropdownItem,
  Button,
  Search,
  DatetimePicker,
  Form,
  Field,
  Popup,
  Picker,
  NavBar,
  Overlay,
  Notify
} from 'vant'
import bpmApi from '@/api/activityBPM/index'
import { formatDate } from '../../util/formatUtil'
import * as globalSearchApi from '../../api/globalSearch'
export default {
  data() {
    return {
      data: [],
      globalData: [],
      active: 0,
      queryParams: {
        page: 1,
        size: 10,
        params: {
          keyword: '',
          procDefKey: '', //流程key
          startTime1: '', //开始时间1
          startTime2: '', //开始时间2
          endTime1: '', //结束时间1
          endTime2: '', //结束时间2
          dealTime1: '',//处理时间1
          dealTime2: '', //处理时间2
          procDefKeyList: []
        }
      },
      type: '1', //1待办： 2我发起的， 3我处理的， 4抄送我的
      keyList: [],
      loadData: false,
      finished: false,
      totalCount: 0, //总数据量
      briefDialog: false,
      briefData: {},
      value: 0,
      option: [
        { text: '最新数据', value: 0 }
        // { text: '最早数据', value: 1 },
      ],
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      showPicker: false,
      showProcPicker: false,
      timePicker: '',
      procName: '',
      procList: [],
      procNameList: [],
      isMobile: false,
      loading: false
    }
  },
  components: {
    [Step.name]: Step,
    [Steps.name]: Steps,
    [Empty.name]: Empty,
    [List.name]: List,
    [Icon.name]: Icon,
    [Dialog.Component.name]: Dialog.Component,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Button.name]: Button,
    [Search.name]: Search,
    [DatetimePicker.name]: DatetimePicker,
    [Field.name]: Field,
    [Form.name]: Form,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [NavBar.name]: NavBar,
    [Overlay.name]: Overlay,
    [Notify.name]: Notify
  },
  computed: {
    userInfo() {
      return this.$store.state.user || {}
    }
  },
  mounted() {
    // this.getServiceProcess() //获取流程
    let type = this.$route.query.type
    if (type) {
      this.type = type
    }
    //直接从VUEX 读取
    this.keyList = this.$store.state.process.keyList
    if (
      navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    ) {
      // 检测是否手机端
      this.isMobile = true
    }
    if (this.type == '1') {
      this.getAwaitWork() //1待办：
    } else {
      this.onLoad('restore')
    }
  },
  filters: {
    //文字数超出时，超出部分使用...
    ellipsis(value) {
      if (!value) return ''
      if (value.length > 10) {
        return value.slice(0, 10) + '...'
      }
      return value
    }
  },
  methods: {
    timeOnClick(time) {
      this.showPicker = true
      this.timePicker = time
    },
    isFilter() {
      let result = false
      Object.keys(this.queryParams.params).forEach((key) => {
        if (this.queryParams.params[key] && this.queryParams.params[key].length) {
          result = true
        }
      })
      return result
    },
    onConfirm(time) {
      if (this.timePicker == 'startTime1') {
        this.queryParams.params.startTime1 = formatDate(time, 'yyyy/MM/dd HH:mm:ss')
      } else if (this.timePicker == 'startTime2') {
        this.queryParams.params.startTime2 = formatDate(time, 'yyyy/MM/dd HH:mm:ss')
      } else if (this.timePicker == 'endTime1') {
        this.queryParams.params.endTime1 = formatDate(time, 'yyyy/MM/dd HH:mm:ss')
      } else if (this.timePicker == 'endTime2') {
        this.queryParams.params.endTime2 = formatDate(time, 'yyyy/MM/dd HH:mm:ss')
      }else if (this.timePicker == 'dealTime1') {
        this.queryParams.params.dealTime1 = formatDate(time, 'yyyy-MM-dd HH:mm:ss')
      } else if (this.timePicker == 'dealTime2') {
        this.queryParams.params.dealTime2 = formatDate(time, 'yyyy-MM-dd HH:mm:ss')
      }
      this.showPicker = false
    },
    onConfirmProc(procName) {
      this.showProcPicker = false
      this.queryParams.params.procDefKey = procName?.toLowerCase()
    },
    onSubmit(values) {
      this.queryParams.page = 1
      this.onLoad('restore')
      this.$refs.item.toggle()
    },
    getProcName(val) {
      var regex = new RegExp(val.toString())
      var nameList = []
      this.procNameList.forEach((obj) => {
        nameList.push(obj.title)
      })
      this.procList = nameList.filter((obj) => {
        return regex.test(obj)
      })
    },
    clearData() {
      //清空表单数据
      this.queryParams.params.procDefKey = ''
      this.queryParams.params.startTime1 = ''
      this.queryParams.params.startTime2 = ''
      this.queryParams.params.endTime1 = ''
      this.queryParams.params.endTime2 = ''
      this.queryParams.params.dealTime1 = ''
      this.queryParams.params.dealTime2 = ''
      //刷新页面
      this.onLoad('restore')
    },
    getServiceProcess() {
      this.showProcPicker = true
      let _this = this
      let type = this.type
      if (type == 2) {
        type = 3
      } else if (type == 3) {
        type = 2
      }
      let params = { serveName: 'eip-mapp-oa-server', type: type }
      globalSearchApi.typeCountByEs(params).then((res) => {
        if (res.success) {
          _this.procNameList = res.data || []
          res.data.forEach((obj) => {
            this.procList.push(obj.title)
          })
        } else {
          if (res.code !== '0500') {
            _this.$message.error(res.msg)
          }
        }
      })
    },
    getAwaitWork() {
      //获取待办
      let _this = this
      let params = JSON.parse(JSON.stringify(this.queryParams))
      if (!params.params.procDefKey) {
        params.params.procDefKeyList = this.keyList
      }
      let timer = setTimeout(() => {
        Notify({ type: 'warning', message: '正在加载中，请勿刷新' })
      }, 10000)
      this.loadData = true
      bpmApi.task
        .listPage(params)
        .then((res) => {
          clearTimeout(timer)
          this.loadData = false
          if (res.code != '0000') {
            this.$message({
              type: 'error',
              message: res.msg
            })
            return
          }
          _this.data = res.data.content || []
          if (this.type == '3') {
            _this.data.sort((a, b) => {
              return a.myApprovalTask.approvalTime < b.myApprovalTask.approvalTime
                ? 1
                : -1
            })
          }
        })
        .catch(() => {
          this.finished = true
          this.loadData = false
          clearTimeout(timer)
        })
    },
    onClickFlow(item) {
      if (item.procExtends) {
        this.$router.push({
          path:
            '/ddFlow?f=mb&funCode=' +
            item.procExtends.funCode +
            '&id=' +
            item.businessKey
        })
      } else {
        this.$router.push({
          path:
            '/ddFlow?f=mb&funCode=' +
            item.funCode +
            '&id=' +
            item.id +
            '&keyword=' +
            this.queryParams.params.keyword
        })
      }
    },
    onLoad(restore) {
      if (restore !== 'restore') {
        this.queryParams.page += 1
      } else {
        this.queryParams.page = 1
      }
      // 我发起的、我处理的
      let params = JSON.parse(JSON.stringify(this.queryParams))
      if (!params.params.procDefKey) {
        params.params.procDefKeyList = this.keyList
      } else if (this.queryParams.params.procDefKey) {
        this.procNameList.forEach((item) => {
          if (item.title == this.queryParams.params.procDefKey) {
            params.params.procDefKey = item.index
          }
        })
      }
      if (
        (!this.queryParams.params.startTime1 && this.queryParams.params.startTime2) ||
        (this.queryParams.params.startTime1 && !this.queryParams.params.startTime2)
      ) {
        this.$message.warning('请输入完整的提交审批时间')
        return
      } else if (
        (!this.queryParams.params.endTime1 && this.queryParams.params.endTime2) ||
        (this.queryParams.params.endTime1 && !this.queryParams.params.endTime2)
      ) {
        this.$message.warning('请输入完整的完成审批时间')
        return
      }else if (
        (!this.queryParams.params.dealTime1 && this.queryParams.params.dealTime2) ||
        (this.queryParams.params.dealTime1 && !this.queryParams.params.dealTime2)
      ) {
        this.$message.warning('请输入完整的任务处理时间')
        return
      }
      let timer = setTimeout(() => {
        Notify({ type: 'warning', message: '正在加载中，请勿刷新' })
      }, 10000)
      this.loadData = true
      let value =
        this.type == '2'
          ? 'getMyStart'
          : this.type == '3'
          ? 'getMyHandled'
          : 'getMySend'
      globalSearchApi[value]({
        optionList: [
          this.queryParams.params.startTime1 || this.queryParams.params.startTime2 ?
              {
                name: 'taskCreateTime',
                optionType: 'EQ',
                value:
                  this.queryParams.params.startTime1 +
                  ',' +
                  this.queryParams.params.startTime2
              } :{},
              this.queryParams.params.endTime1 || this.queryParams.params.endTime2 ?
            {
                name: 'taskEndTime',
                optionType: 'EQ',
                value:
                  this.queryParams.params.endTime1 +
                  ',' +
                  this.queryParams.params.endTime2
              } : {}
        ],
        page: this.queryParams.size * (this.queryParams.page - 1),
        params: {
          keyWord: this.queryParams.params.keyword,
          taskStatus: '',
          procDefKey: params.params.procDefKey,
          serveName: 'eip-mapp-oa-server',
          optionList:
          this.queryParams.params.dealTime1 || this.queryParams.params.dealTime2 ?
          [
            {
                name: 'handledUser.taskEndTime',
                optionType: 'EQ',
                value:
                  this.queryParams.params.dealTime1 +
                  ',' +
                  this.queryParams.params.dealTime2
              }
          ]: []

        },
        size: this.queryParams.size
      })
        .then((res) => {
          clearTimeout(timer)
          if (res.code == '0000') {
            let dbData = []
            res.data.hits.hits.forEach((item) => {
              item._source['id'] = item._id
              dbData.push(item._source)
            })
            if (restore === 'restore') {
              this.globalData = dbData || []
            } else {
              this.globalData = this.globalData.concat(dbData || [])
            }
            this.totalCount = res.data.hits.total.value
            this.$forceUpdate()
            if (this.globalData.length >= this.totalCount) {
              this.finished = true
            } else {
              this.finished = false
            }
            this.loadData = false
          }
        })
        .catch(() => {
          this.finished = true
          this.loadData = false
          clearTimeout(timer)
        })
    },
    getApprovalColor(item) {
      if (item.status == 2) {
        if (item.approvalStatus == 'APPROVAL' || item.approvalStatus == 'DISAGREE') {
          return 'success'
        } else if (item.approvalStatus == 'REJECT') {
          return 'danger'
        }
      } else if (item.status == 3 && item.approvalStatus == 'REVOKE') {
        return 'danger'
      } else {
        const statusMap = new Map([
          ['APPROVAL', 'flow-state'],
          ['DISAGREE', 'flow-state'],
          ['REJECT', 'flow-reject'],
          ['REVOKE', 'flow-reject']
        ])
        return item.nowTaskName ? 'flow-commit' : statusMap.get(item.taskStatus)
      }
    },
    getApprovalStatusStr(item) {
      if (item.status) {
        if (item.status == 2) {
          if (item.approvalStatus == 'APPROVAL' || item.approvalStatus == 'DISAGREE') {
            return '审批通过'
          } else if (item.approvalStatus == 'REJECT') {
            return '被驳回'
          } else {
            return '已结束'
          }
        } else if (item.status == 3 && item.approvalStatus == 'REVOKE') {
          return '已撤回'
        } else {
          return '审批中'
        }
      } else {
        const statusMap = new Map([
          ['APPROVAL', '审批通过'],
          ['DISAGREE', '审批通过'],
          ['REJECT', '被驳回'],
          ['REVOKE', '已撤回'],
          ['COMMIT', '审批中'],
          ['RECALL', '审批中']
        ])
        var flowStatus = item.nowTaskName ? '审批中' : statusMap.get(item.taskStatus)
        return item.taskEndTime && flowStatus === '审批中' ? '已结束' : flowStatus
      }
    },
    onClickLeft() {
      this.$router.push({
        path: '/mobile'
      })
    }
  }
}
</script>
<style scoped>
.flow-commit {
  background: rgb(236, 245, 255);
  color: #409eff;
  border: 1px solid #409eff;
  width: 70px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  border-radius: 100px;
  font-size: 12px;
  /* float: right; */
}
.flow-state {
  background: #ebf8f7;
  color: #0db3a6;
  border: 1px solid #0db3a6;
}
.flow-reject {
  background: rgb(254, 240, 240);
  color: #f56c6c;
  border: 1px solid #f56c6c;
}
span.formName {
  font-weight: bold;
  font-size: 14px;
}
.span {
  font-size: 15px;
  color: black;
  margin-left: auto;
}
.topBar {
  width: 100%;
  position: fixed;
  z-index: 10;
}
.isMobile {
  top: 0;
}
.notMobile {
  top: 46px;
}
::v-deep .van-step__title {
  transition: color 0.3s;
  display: flex;
}
::v-deep .van-step--vertical:not(:last-child)::after {
  border-bottom-width: 0px;
}
::v-deep .van-steps {
  overflow: inherit;
  background-color: #fff;
}
.card-back {
  height: 20px;
  background-color: #f6f6f6;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
::v-deep .van-nav-bar__text {
  color: #000000;
}
::v-deep .van-nav-bar .van-icon {
  color: #000000;
}
::v-deep .van-dropdown-menu__bar {
  box-shadow: 0 12px 12px -12px rgb(100 101 102 / 12%);
}
</style>
